module.exports = __webpack_public_path__ + "static/media/logo_scbbank.6f0d4baf.svg";